import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: var(--t-brand-fg-color);
`;

export const StarGroupWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const SingleStarWrapper = styled.div`
  display: flex;
  align-items: center;
  color: var(--t-brand-fg-color);
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TextInteractiveWrapper = styled.div`
  display: flex;
  align-items: center;
`;
